import { CircuitProperty, Feature, HeatingCircuitCommands } from '@vi-iot/client';

import { RichDevice } from './devices.state';

export enum WallboxChargingModes {
  GREEN = 'green',
  MIXED = 'mixed',
}

export enum WallboxChargingSubstatus {
  PV_EXCESS_NOT_SUFFICIENT = 'pvExcessNotSufficient',
  CHARGING_WITH_REDUCED_POWER = 'chargingWithReducedPower',
  OVERLOAD_PROTECTION_ACTIVE = 'overloadProtectionActive',
}

export interface WallboxDevicesWithMatchingBoilerSerial extends RichDevice {
  wallboxIndex: string; // boilerSerial + eebus index - example: 7727502101419129-1
  boilerSerial: string;
}

export interface CircuitDetails {
  feature: Feature<CircuitProperty, HeatingCircuitCommands>;
  circuitId: string;
}

export const DIAGNOSIS_ANOMALY = '1';
